// SideBar
//
//  desc:
//    parent container for anything to be displayed in a side bar. (usually the nav menu)
//  required props:
//    TBD
//

import React, { Component } from 'react';
import './index.css'

import MenuLegacy from './MenuLegacy';
import { MIRetriever } from '../Login/MerchantInfo.js'


// derived from ASP ssoCommonParent
function SSO (target, targetOrigin, merchantId) {
  this.target = target
  this.targetOrigin = targetOrigin
  this.merchantId = merchantId
  this.customQueryParams = ""

  window.addEventListener('message', (event) => {

    if (event.origin !== this.targetOrigin) {
      return
    }

    const eventData = event.data

    switch (eventData.key) {
      case 'ping':
        console.debug('SSOParent: Ping received from SSO frame ' + eventData.payload)
        return

      case 'getRefreshTokenResponse':
        console.debug('Refresh token received from SSO frame')
        this.loadStitchIfNotExists(eventData.payload)
        return

      default:
        console.debug('SSOParent: Unknown event key received ' + eventData.key)
    }
  })

  this.sendMessage = function (message) {
    if (!this.target.contentWindow) {
      console.error('Unable to send message')
      return
    }
    this.target.contentWindow.postMessage(message, this.targetOrigin)
  }

  this.ping = function () {
    this.sendMessage({ key: 'ping' })
  }

  this.getRefreshToken = function () {
    this.sendMessage({ key: 'getRefreshToken' })
  }

  this.initializeWithToken = function (refreshToken) {
    this.sendMessage({ key: 'initializeWithToken', payload: { refreshToken } })
  }

  this.initializeWithCredentials = function (username, password) {
    this.sendMessage({ key: 'initializeWithCredentials', payload: { username, password } })
  }

  this.invalidateTokens = function () {
    this.sendMessage({ key: 'invalidateTokens' })
  }

  this.loginFormHook = function () {
    var username = document.querySelector("[name='UN']").value
    var password = document.querySelector("[name='PSWD']").value
    this.initializeWithCredentials(username, password)
  }

  // Stitch-related methods are adapted from sso.js
  this.appendCustomQueryParameters = function (params) {
    // to add any query parameters needed for new frontend
    // params should be in url query format: value1=foo&value2=bar
    this.customQueryParams = params
  }

  this.doAdaptiveNavStitching = function (refreshToken) {
    if (refreshToken) {
      var stitch_script = document.createElement("script")

      stitch_script.src = this.targetOrigin +
        "/stitch.js?merchant_id=" + this.merchantId +
        "&jwt=" + refreshToken

      if (this.customQueryParams != "") {
        stitch_script.src = stitch_script.src +
          "&" + this.customQueryParams
      }

      document.body.append(stitch_script)
    } else {
      console.error("SSOParent ERROR: doAdaptiveNavStitching() skipped due to missing or invalid RT!")
    }
  }

  this.loadStitchIfNotExists = function (refreshToken) {
    if (window.stitch) {
      console.debug('SSOParent: Existing stitch found.  Skipping stitch load from common SSO token.')
      return
    }

    console.debug('SSOParent: Loading stitch from Common SSO refresh token.')
    this.doAdaptiveNavStitching(refreshToken)
  }

  this.stitchFallbackHook = function () {
    if (window.stitch) {
      console.debug("SSOParent: Existing stitch found. Skipping load from SSO Frame")
      return
    }
    console.log("SSOParent: Existing stitch not found. Attempting to load from SSO Frame")
    this.getRefreshToken()
  }
}

function addStitchViaIframe (e) {
  MIRetriever.getMerchantInfo(({merchantInfo}) => {
    console.debug('Stitch MIRetriever recv: ', merchantInfo)

    if (!merchantInfo || !merchantInfo.merchant_id) {
      console.debug("Skipping stitch.js addition, no merchantId found.")
      return
    }
    const merchantId = merchantInfo.merchant_id
    const iframe = e.target
    // more reliable than string parsing to get the root domain/origin
    const el = document.createElement('a')
    el.href = iframe.src
    const targetOrigin = el.origin
    const sso = new SSO(iframe, targetOrigin, merchantId)
    sso.getRefreshToken() // Will side-effect stitch.js loading and link manipulation
  }, true) // bypass headers to get plain merchant_id
}


class SideBar extends Component {

  constructor(props)
  {
    super(props);


    this.state =
    {
      menu_nodes: "loading",
      authorized: true,
    };
  }


  componentDidMount()
  {
    var menu_url = process.env.API_URL + '/menu/get_markup';
    // TODO: render menu based off of configuration maybe?
    // returning a fake menu should figure a way to work locally without
    // needing to get external resource
    // if (false) {
    //     var data = "<ul>\
    //         <li>\
    //             <a href='#' user-action='Dashboard'>\
    //             <i className='icon-home'></i>Dashboard</a></li>\
    //             <li className='submenu'>\
    //                 <a href='#adminmenu'><i className='fa fa-fw fa-caret-right'></i>Admin</a>\
    //                 <ul id='adminmenu'>\
    //                 </ul>\
    //             </li>\
    //         </li>\
    //     </ul>"

    //     const doc = new DOMParser().parseFromString(data, "text/html");
    //     this.setState({menu_nodes: doc.body, authorized: true});
    //     return;
    // }

    let requestSettings = {
      credentials: "include",
      headers: {
        "PayTrace-Product": "paymentlink"
      }
    };

    fetch(menu_url, requestSettings).then(results =>
    {
      return results.text();
    }).then(data =>
    {

      if (data.indexOf("NotAuthorized") != -1)
      { //testing to see if we got an not authorized response.... we dont want to try rendering certain things if we arent logged in
         this.setState({authorized: false});
        return;
      }

      const doc = new DOMParser().parseFromString(data, "text/html");
      this.setState({menu_nodes: doc.body, authorized: true});
    })
  }


  render() {
    let menu;
    if (this.state.authorized == false)
    { //testing to see if we got an not authorized response.... we dont want to try rendering certain things if we arent logged in
      menu = <div> please login to continue... </div>
    }
    else if (this.state.menu_nodes == "loading" )
    {
      menu = <div> loading... </div>
    }
    else
    {
      menu =  <MenuLegacy menu_nodes={this.state.menu_nodes}/>
    }

    const ssoSrc = `${process.env.BFF_DOMAIN}/v3/assets/ssoCommon.html`

    return (
        <div className='sidebar'>
          {menu}
          <iframe src={ssoSrc} hidden={true} onLoad={addStitchViaIframe} />
        </div>
     );
  }
}

export default SideBar;
